import React, { CSSProperties, useEffect, useState } from 'react';
import styles from './searchInputTop.module.css';
import { ContractType, useSearchBarContext } from '../../store/searchBar.store';
import OptionsIcon from '../../assets/images/Icon-ionic-md-options.svg';
import Button from '../button';
import SearchInputTopFilterModal from './SearchInputTopFilterModal';
import { useCreateLogApi } from '../../hooks/api/log.hook';
import { LogControlName, LogFormName } from '../../utils/log.utils';

const contractTypeText: Record<ContractType, string> = {
  ELECTRONIC: '：電子契約',
  PAPER: '：書面契約',
  ALL: '',
};

function SearchInputTop({ className = '', style = {} }: { className?: string, style?: CSSProperties }) {
  const searchBar = useSearchBarContext();
  const [text, setText] = useState('');
  const [showFilterMenu, setShowFilterMenu] = useState(false);
  const [showAdvancedFilterMenu, setShowAdvancedFilterMenu] = useState(false);
  const { request: createLog } = useCreateLogApi();

  const onKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      createLog(LogFormName.Main, LogControlName.Search);
      searchBar.setIsSearching(true);
      searchBar.setText(undefined);
      Promise.resolve().then(() => {
        searchBar.setText((e.target as HTMLInputElement).value);
      });
    }
  };

  const handleKeyUp = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      (e.target as HTMLInputElement).blur();
    }
  };

  useEffect(() => {
    if (!searchBar.isSearching) {
      setText('');
    }
  }, [searchBar.isSearching]);

  useEffect(() => {
    if (searchBar.isSearching) {
      setText('');
      searchBar.setText(undefined);
    }
  }, [searchBar.advancedSearch]);

  useEffect(() => {
    if (searchBar.text) {
      setText(searchBar.text);
    }
  }, [searchBar.text]);

  return searchBar.inUse
    ? (
      <div className={[styles.container, className].join(' ')} style={style}>
        <div className={styles.searchBox}>
          <img className={styles.searchImg} alt="" src="images/search.svg" />
        </div>
        <div style={{ position: 'relative', flex: 1 }}>
          <input
            className={styles.input}
            value={text}
            onChange={(e) => setText(e.target.value)}
            onKeyPress={onKeyPress}
            onFocus={() => setShowFilterMenu(true)}
            onBlur={() => setShowFilterMenu(false)}
            onKeyUp={handleKeyUp}
          />
          {
            (showFilterMenu && searchBar.isSearching)
            && (
            <div className={styles['filter-dropdown']}>
              <Button
                className={styles['filter-button']}
                size="smaller"
                outline
                color={searchBar.warehouseStatus === false ? 'lightGray' : 'orange'}
                background={searchBar.warehouseStatus === false ? 'white' : 'lighterOrange'}
                onClick={searchBar.toggleWarehouseStatus}
                onMouseDown={(e) => e.preventDefault()}
              >
                ステータス
                {searchBar.warehouseStatus ? '：未入庫' : ''}
              </Button>
              <Button
                className={styles['filter-button']}
                size="smaller"
                outline
                color={searchBar.contractType === 'ALL' ? 'lightGray' : 'orange'}
                background={searchBar.contractType === 'ALL' ? 'white' : 'lighterOrange'}
                onClick={searchBar.toggleContractType}
                onMouseDown={(e) => e.preventDefault()}
              >
                契約種類
                {contractTypeText[searchBar.contractType]}
              </Button>
            </div>
            )
          }
        </div>
        <div>
          <img className={styles.filterButton} alt="" width="30" src={OptionsIcon} onClick={() => setShowAdvancedFilterMenu(!showAdvancedFilterMenu)} />
          {showAdvancedFilterMenu && <SearchInputTopFilterModal open={showAdvancedFilterMenu} onClose={() => setShowAdvancedFilterMenu(false)} />}
        </div>
      </div>
    )
    : <div className={className} style={style} />;
}

export default SearchInputTop;
